import React from "react";
import style from "../../assets/css/static-page.module.scss";
import {Grid} from "@mui/system";
import {Breadcrumbs, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import home from "../../assets/css/home.module.scss";
import jwBlockImg from "../../assets/img/static/jw-block-img.webp";
import jwBlockShapeImg from "../../assets/img/static/jwBlockShape.svg";
import WholesaleImg from "../../assets/img/home/Wholesale.svg";
import RetailImg from "../../assets/img/home/Retail.svg";
import PreciousMetalsImg from "../../assets/img/home/precious-metals.webp";
import ManufacturingImg from "../../assets/img/home/Manufacturing.svg";
import WatchTradeImg from "../../assets/img/home/Watch-Trade.svg";
import PawnbrokersImg from "../../assets/img/home/Pawnbrokers.svg";
import FineArtImg from "../../assets/img/home/Fine-Art-Dealers.svg";

import premisesImg from "../../assets/img/home/premise.svg";
import outsideImg from "../../assets/img/home/out-side.svg";
import operationsImg from "../../assets/img/home/work-operation.svg";
import TravelImg from "../../assets/img/home/travel.svg";
import consignmentImg from "../../assets/img/home/consignment.svg";
import exhibitionsImg from "../../assets/img/home/echibition.svg";

const JewelersBlock = () => {
  return (
    <>
      <section className={style.contactSection}>
        <Grid container spacing={2}>
          <Grid size={{xs: 12}} sx={{m: 2}}>
            <div className={style.staticPageBanner}>
              <div>
                <span> Jewelers Block </span>
                <h1> Jewelry Protection Insurance</h1>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link underline="hover" color="inherit" to="/">
                    Home
                  </Link>
                  <Typography sx={{color: "text.primary"}}>
                    Jewelers Block{" "}
                  </Typography>
                </Breadcrumbs>
              </div>
            </div>
          </Grid>
        </Grid>
      </section>

      <section className={style.jeleryBlockSection}>
        <Grid
          container
          spacing={2}
          className="customeContainer"
          justifyContent="center"
        >
          <Grid size={{xs: 12, lg: 9}}>
            <div className={style.JbText1}>
              <p className={style.hmAboutContentBox_p}>
                Jewelry Retailers, Diamond and Jewelry Wholesalers,
                Manufacturers who trade Diamonds, Precious metals and watches
                require a knowledgeable industry expert when choosing their
                insurance carrier.
              </p>
            </div>
          </Grid>

          <Grid
            container
            spacing={2}
            className="customeContainer"
            justifyContent="center"
            alignItems="center"
          >
            <Grid size={{xs: 12, lg: 6}}>
              <div className={style.jwBlockImg}>
                <img src={jwBlockImg} alt="expertise-img" />

                <div className={style.jwBlockShapeLeft}>
                  <img src={jwBlockShapeImg} alt="shape1" />
                </div>

                <div className={style.jwBlockShapeRight}>
                  <img src={jwBlockShapeImg} alt="shape2" />
                </div>
              </div>
            </Grid>

            <Grid size={{xs: 12, lg: 6}}>
              <div className={style.jwBlocktextRight}>
                <h2>
                  Providing expertise to the Unique Needs of the Jewelry
                  Industry
                </h2>
                <p>
                  With over 30 years of industry experience we understand the
                  risks involved in the jewelry industry and what it takes to
                  protect your inventory risk. Associated International Brokers,
                  Inc offers coverage for physical loss to diamonds, precious
                  and semi-precious stones, jewelry, precious metals and
                  watches, including consigned property.
                </p>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </section>

      <section className={home.expertiseSection}>
        <Grid
          container
          spacing={3}
          className="customeContainer"
          justifyContent="center"
        >
          <Grid size={{xs: 12, lg: 12}}>
            <div className={home.titleMain}>
              <h2> Our areas of expertise </h2>
              <p>
                Get your valuables covered against risks from accidental damage,
                fire, burglary &amp; theft.
              </p>
            </div>

            <div className={home.expertiBoxMain}>
              <div className={home.expertiBox}>
                <img src={WholesaleImg} alt="WholesaleImg" />
                <p> Wholesale </p>
              </div>
              <div className={home.expertiBox}>
                <img src={RetailImg} alt="RetailImg" />
                <p> Retail </p>
              </div>
              <div className={home.expertiBox}>
                <img src={PreciousMetalsImg} alt="PreciousMetalsImg" />
                <p> Precious Metals </p>
              </div>
              <div className={home.expertiBox}>
                <img src={ManufacturingImg} alt="ManufacturingImg" />
                <p> Manufacturing </p>
              </div>
              <div className={home.expertiBox}>
                <img src={WatchTradeImg} alt="WatchTradeImg" />
                <p> Watch Trade </p>
              </div>
              <div className={home.expertiBox}>
                <img src={PawnbrokersImg} alt="PawnbrokersImg" />
                <p> Pawnbrokers </p>
              </div>
              <div className={home.expertiBox}>
                <img src={FineArtImg} alt="FineArtImg" />
                <p> Fine Art Dealers </p>
              </div>
            </div>
          </Grid>
        </Grid>
      </section>

      <section className={style.insuringSection}>
        <Grid
          container
          spacing={3}
          className="customeContainer"
          justifyContent="center"
        >
          <Grid size={{xs: 12, lg: 12}}>
            <div className={home.titleMain}>
              <h2> Insuring </h2>
              {/* <p>
                Get your valuables covered against risks from accidental damage, fire, burglary &amp; theft.
              </p> */}
            </div>

            <div className={home.expertiBoxMain}>
              <div className={home.expertiBox}>
                <img alt="premises" src={premisesImg} />
                <p> Premises </p>
              </div>
              <div className={home.expertiBox}>
                <img alt="Outside" src={outsideImg} />
                <p> Outside Exposures </p>
              </div>

              <div className={home.expertiBox}>
                <img alt="Work" src={operationsImg} />
                <p> Work and Operations </p>
              </div>
              <div className={home.expertiBox}>
                <img alt="Travel" src={TravelImg} />
                <p> Travel </p>
              </div>
              <div className={home.expertiBox}>
                <img alt="Consignment" src={consignmentImg} />
                <p> Consignment </p>
              </div>
              <div className={home.expertiBox}>
                <img alt="Exhibitions" src={exhibitionsImg} />
                <p> Exhibitions </p>
              </div>
            </div>
          </Grid>
        </Grid>
      </section>
    </>
  );
};

export default JewelersBlock;
